import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ResultpageService } from '../../../../share/service/resultpage.service';
import { Agent } from '../../../../share/type/result_type';

interface ICallCenter {
  contactEmail?: string;
  contactPhoneNumber?: string;
  businessHours: string;
  businessHoursFromToday: string;
  businessHoursUntilToday: string;
  firstName: string;
  lastName: string;
  urlImage?: string;
  gender: string;
}

declare const wf_call_center: ICallCenter;

@Component({
  selector: 'app-sales-agent-box',
  templateUrl: './sales-agent-box.component.html',
  styleUrls: ['./sales-agent-box.component.scss'],
})
export class SalesAgentBoxComponent implements OnInit, OnDestroy {
  @Input() offerId?: string;
  public agent = '/resultpage/assets/img/agent/agent.gif';
  private token!: string;
  public dataAgent!: Agent | ICallCenter;

  private subGet?: Subscription;
  private offersSubscription?: Subscription;

  public showMore: boolean = false;

  public callCenter: ICallCenter = wf_call_center;

  constructor(private resultpageService: ResultpageService) {}

  ngOnInit(): void {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.token = urlParams.get('t') ?? '';

    const createCallCenter = ({
      contactEmail,
      contactPhoneNumber,
      urlImage,
      ...rest
    }: ICallCenter) => ({
      email: contactEmail,
      phoneNumber: contactPhoneNumber,
      image: urlImage,
      gender: 'MALE',
      ...rest,
    });

    if (this.token) {
      this.dataAgent = createCallCenter(wf_call_center);
      this.offersSubscription = this.resultpageService.offersDataObserv$
        .pipe(
          filter(
            (data) => data !== 1 && Array.isArray(data) && data.length > 0,
          ),
          take(1),
        )
        .subscribe(() => this.fetchAgentForResultPage());
    } else {
      this.getAgentDataEternalPage();
    }
  }

  ngOnDestroy(): void {
    this.offersSubscription?.unsubscribe();
    this.subGet?.unsubscribe();
  }

  private fetchAgentForResultPage(): void {
    this.subGet?.unsubscribe();
    this.subGet = this.resultpageService
      .getAgentData(this.token)
      .subscribe((data: Agent) => {
        this.dataAgent = data;
      });
  }

  getAgentDataEternalPage(): void {
    this.subGet?.unsubscribe();
    this.subGet = this.resultpageService
      .getAgentDataForOffer(this.offerId)
      .subscribe((data: Agent) => {
        this.dataAgent = data;
      });
  }

  onToggleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.showMore = !this.showMore;
    }
  }
}
